export const timed = async <T>(
	promise: Promise<T>,
): Promise<{
	durationMs: number;
	result: T;
}> => {
	const startTime = Date.now();
	const result = await promise;
	const duration = Date.now() - startTime;
	return {
		result,
		durationMs: duration,
	};
};
